import { FormattedMessage } from 'react-intl';

import { useUpdateUserPreferencesMutation } from '@/api/user/index.ts';
import { EmailsInput } from '@/components/ui/EmailsInput';
import { useAppSelector } from '@/store/hooks.ts';
import { getUserPreferences } from '@/store/userPreferences/slice.ts';

const SplitNotificationsEmailsOrders = () => {
  const [updateUserPreferences] = useUpdateUserPreferencesMutation();
  const userPreference = useAppSelector(getUserPreferences);

  const handleChange = (splitNotificationsEmailsOrders: string[]) => {
    updateUserPreferences({ ...userPreference, splitNotificationsEmailsOrders });
  };

  return (
    <div>
      <p className="mt-2 mb-2">
        <FormattedMessage id="userPreferences.section.SplitNotificationsEmailsOrders" />
      </p>
      <EmailsInput
        emails={userPreference.splitNotificationsEmailsOrders}
        onChange={handleChange}
        dataE2e="user-preferences-notifications-emails-for-orders"
      />
    </div>
  );
};

export default SplitNotificationsEmailsOrders;
